import { render } from "./setup-questions.vue?vue&type=template&id=782a6245"
import script from "./setup-questions.vue?vue&type=script&lang=js"
export * from "./setup-questions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__